import type { SelectBoxProps } from "@made-people/blueprint-form";

export const SelectBoxDefaults: SelectBoxProps = {
  variants: {
    style: "border",
    rounded: "md",
  },
  label: false,
};
